import {
  BLOCK_MARKER_REGEX,
  replaceBlockMarkers,
} from '@spotify/confidence-conversation-react';

export const INLINE_BLOCK_TAG = 'inline-block';

// Emitted directly by the agent's create_number_block tool, wrapping a
// numeric value that is already part of the response text.
export const PULSE_NUMBER_TAG = 'pulse-num';

const PULSE_NUMBER_MARKER_REGEX = /<pulse-num\b[^>]*>([\s\S]*?)<\/pulse-num>/g;

// For clipboard/export paths: keeps the value text, drops the markup.
export const stripPulseNumberMarkers = (markdown: string): string =>
  markdown.replace(PULSE_NUMBER_MARKER_REGEX, '$1');

export { BLOCK_MARKER_REGEX };

const escapeAttribute = (value: string): string =>
  value.replace(/&/g, '&amp;').replace(/"/g, '&quot;');

// The close tag goes on its own line so that a marker occupying a whole
// markdown paragraph is parsed as an HTML block (CommonMark type 7) instead of
// being wrapped in a <p>, which would nest the rendered block inside it.
export const convertBlockMarkers = (markdown: string): string =>
  replaceBlockMarkers(
    markdown,
    ({ name }) =>
      `<${INLINE_BLOCK_TAG} data-name="${escapeAttribute(name)}">\n</${INLINE_BLOCK_TAG}>`,
  );
